export default __webpack_public_path__ + "static/media/cr6.d40938a0.jpg";